/* src/app/shared/shop/variant-chips/variant-chips.component.scss */
label {
  z-index: 1;
}
.overflow {
  max-height: 70%;
}
.selection-group .selection label {
  display: inline-block;
  border-radius: 10px;
  color: black;
  padding: 5px 10px;
  cursor: pointer;
  font-family: Barlow Semi Condensed;
  line-height: 28.8px;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  font-variant-caps: normal;
  background-color: white;
}
.selection-group .selection label.disabled {
  color: rgba(0, 154, 207, 0.3);
  outline: 2px solid rgba(0, 154, 207, 0.3);
}
.selection {
  display: flex;
  flex-direction: column;
}
.selection .discount-div {
  background: #ff007f;
  color: white;
  display: flex;
  justify-content: center;
  padding: 10px 0;
  z-index: 0;
  margin-top: -15px;
  border-radius: 5px;
}
.selection .discount-div span {
  transform: translateY(6px);
}
.selection-group .selection .selector:hover label.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  border-color: rgba(0, 154, 207, 0.3);
}
.selection-group .selection input[type=radio] {
  display: none;
}
.selection-group .selection input[type=radio]:checked ~ .selector label {
  outline: none;
}
.selection-group .selection input[type=radio]:checked ~ .selector label.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  outline: 2px solid rgba(0, 154, 207, 0.3);
}
.selector {
  cursor: pointer;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 5px;
  border: 1px solid #cbcbcb;
}
.selector .img-selector {
  width: 50px;
  height: 50px;
  border-radius: 6px;
  z-index: 1;
}
.selection-group .selection .selector:hover {
  outline: 2px solid #ff007f !important;
  border: 1px solid #ff007f !important;
}
.selection-group .selection .selector:hover.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  border-color: rgba(0, 154, 207, 0.3);
}
.selection-group .selection input[type=radio]:checked ~ .selector {
  border: 2px solid #ff007f;
  background: #fff;
  box-shadow: 0 0 10px 0 rgba(255, 0, 127, 0.8);
}
.selection-group .selection input[type=radio]:checked ~ .selector.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  outline: 2px solid rgba(0, 154, 207, 0.3);
}
.selection-group .selection .pink-selector:hover {
  outline: 2px solid #ff007f !important;
  border: 1px solid #ff007f !important;
}
.selection-group .selection .pink-selector:hover.disabled {
  background-color: rgba(0, 154, 207, 0.3);
  border-color: rgba(0, 154, 207, 0.3);
}
.selection-group .selection input[type=radio]:checked ~ .pink-selector {
  outline: 2px solid #ff007f !important;
  border: 1px solid #ff007f !important;
  box-shadow: 0px 0px 10px 0px rgba(255, 0, 127, 0.8) !important;
}
.selector-checked {
  outline: 2px solid #ff007f;
  border: 1px solid #ff007f;
  box-shadow: 0px 0px 10px 0px rgba(255, 0, 127, 0.8);
}
.blue-selector-checked {
  outline: 3px solid rgb(0, 154, 207) !important;
  box-shadow: 0 0 3px 2px rgba(0, 154, 207, 0.5);
}
.selection-group .selection input[type=radio]:not(:checked) ~ img {
  outline: 2px solid #c9c9c9;
}
/*# sourceMappingURL=variant-chips.component-SNBI62F5.css.map */
